
import { Component, Vue } from 'nuxt-property-decorator'
import type { MetaInfo } from 'vue-meta'
import { AnalyticsOffersList } from '@alao-frontend/analytics.plugin'
import BlackFridayHeader from '~/components/black-friday/BlackFridayHeader.vue'
import BlackFridayEmailForm from '~/components/black-friday/BlackFridayEmailForm.vue'
import Partners from '~/components/black-friday/Partners.vue'
import BPPlans from '~/components/promos/black-promo/BPDeals/BPPlans.vue'
import BlackFridayFeaturesBanner from '~/components/black-friday/BlackFridayFeatureBanner.vue'
import BlackFridayDealsSection from '~/components/black-friday/BlackFridayDealsSection.vue'
import SaveRouteMixin from '~/mixins/save-route.mixin'
import { OnMounted, WithHead } from '~/core/vue.types'
import BlackFridayCompareCards from '~/components/black-friday/BlackFridayCompareCards.vue'
import BlackFridayProviders from '~/components/black-friday/BlackFridayProviders.vue'
import BlackFridayBlogCards from '~/components/black-friday/BlackFridayBlogCards.vue'
import BlackFridayPageBody from '~/components/black-friday/BlackFridayPageBody.vue'
import { NotifiesOfferType } from '~/services/notifier.service'
import BPSection from '~/components/promos/black-promo/snippets/BPSection.vue'
import BPHiw from '~/components/promos/black-promo/BPHiw.vue'
import BPClientsFeedback from '~/components/promos/black-promo/BPClientsFeedback.vue'
import BPFooter from '~/components/promos/black-promo/BPFooter.vue'
import BFFaq from '~/components/black-friday/BFFaq.vue'
import { useSEOMetaComposer } from '~/composables/seo.composable'

@Component({
  components: {
    BPSection,
    BPPlans,
    BlackFridayPageBody,
    BlackFridayHeader,
    BlackFridayEmailForm,
    Partners,
    BlackFridayFeaturesBanner,
    BlackFridayDealsSection,
    BlackFridayCompareCards,
    BlackFridayProviders,
    BlackFridayBlogCards,
    BPHiw,
    BPClientsFeedback,
    BFFaq,
    BPFooter,
  },
  mixins: [SaveRouteMixin],
})
export default class BlackFridayPage
  extends Vue
  implements OnMounted, WithHead {
  public offerType = NotifiesOfferType.MOBILE_OFFER

  readonly listPosition = AnalyticsOffersList.BLACK_FRIDAY_OFFER

  head (): MetaInfo {
    return useSEOMetaComposer(
      this,
      {
        title: this.$t('head.meta.blackFriday.index.title').toString(),
        description: this.$t(
          'head.meta.blackFriday.index.description',
        ).toString(),
        route: { name: 'black-friday-index' },
      },
    )
  }

  mounted (): void {
    this.$analytics.GTM.sendPageViewEvent({
      routeName: this.$route.name as string,
      pageTitle: this.$metaInfo.title || '',
      fullPath: this.$route.fullPath,
      fromPath: this.$nuxt.context.from ? this.$nuxt.context.from.fullPath : '',
      contentGroup: 'Black Friday page',
    })
  }
}
